import React from 'react'
import { useAuthUser } from 'contexts/AuthUserProvider'
import { useNavigate } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import NotificationsIcon from '@mui/icons-material/Notifications';
import BusinessIcon from '@mui/icons-material/Business';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import {
  practiceMemberListURL,
  practiceNotificationURL, 
  practiceProfileEditURL,
} from 'routes/urls'
import { usePractice } from 'contexts/PracticeProvider';
import { List, ListItem, ListItemButton, ListItemText, Paper, Popper } from '@mui/material';
import PracticePicker from 'components/PracticePicker';

const PracticeTopNav: React.FC = () => {
  const { practice, unreadCount$ } = usePractice()
  const { logout } = useAuthUser()
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = React.useState<number>(0)
  const [anchor, setAnchor] = React.useState<HTMLElement | null>(null)
  const logo = process.env.PUBLIC_URL + '/logo-rectangle.png'

  React.useEffect(() => {
    const sub = unreadCount$?.subscribe(setUnreadCount)
    return () => sub?.unsubscribe()
  }, [])

  function goToRoot() {
    navigate('/')
  }

  function toggleMenu(event: React.MouseEvent<HTMLElement>) {
    setAnchor(anchor ? null : event.currentTarget)
  }

  function goToPage(page: 'notification' | 'profile' | 'members') {
    if (!practice) return
    setAnchor(null)
    const practiceId = practice.practice_id
    if (page === 'notification') {
      navigate(practiceNotificationURL(practiceId))
    } else if (page === 'profile') {
      navigate(practiceProfileEditURL(practiceId))
    } else if (page === 'members') {
      navigate(practiceMemberListURL(practiceId))
    }
  }

  const open = Boolean(anchor)

  return (
    <AppBar position="static" color='inherit'>
      <Toolbar variant='regular' disableGutters sx={{ justifyContent: 'flex-end' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, flexGrow: 1, alignItems: 'center' }}>
          <Box component='img' src={logo} alt='logo' sx={{ height: ['1.5rem', '2.5rem'], cursor: 'pointer' }} onClick={goToRoot}></Box>
          <PracticePicker />
        </Box>
        <IconButton onClick={_ => goToPage('notification')}>
            {unreadCount > 0 ? (
            <Badge badgeContent={unreadCount} color="error">
                <NotificationsIcon />
            </Badge>
            ) : (
            <NotificationsIcon />
            )}
        </IconButton>
        <IconButton onClick={toggleMenu}>
            <BusinessIcon />
        </IconButton>
        <IconButton onClick={logout}>
            <PowerSettingsNewIcon />
        </IconButton>
        <Popper open={open} anchorEl={anchor} placement='bottom-end'>
          <Paper elevation={4}>
            <List>
              <ListItem disablePadding onClick={_ => goToPage('profile')}>
                <ListItemButton>
                  <ListItemText primary='Profile' />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding onClick={_ => goToPage('members')}>
                <ListItemButton>
                  <ListItemText primary='Members' />
                </ListItemButton>
              </ListItem>
            </List>
          </Paper>
        </Popper>
      </Toolbar>
    </AppBar>
  )
}

export default PracticeTopNav